// src/web/insights/InsightArticle.jsx

import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { insights } from "../../content/insights";
import ArticleLayout from "../../components/insights/ArticleLayout";
import RelatedArticles from "../../components/insights/RelatedArticles";
import { getReadingTimeFromWords } from "../../utils/text/readingTime";

import PageTracker from '../../components/tracking/PageTracker';
import ScrollTracker from '../../components/tracking/ScrollTracker';

function InsightArticle() {
  const { slug } = useParams();

  const article = insights.find(a => a.slug === slug);

  if (!article) return <div>Article not found</div>;

  const Component = article.Component;

  const readingTime = getReadingTimeFromWords(
    article.wordCount || 800
  );

  return (
    <>
      <PageTracker pageName={`Insight:${slug}`} />
      <ScrollTracker pageName={`Insight:${slug}`} />
      <Helmet>
        <title>{article.meta.title} | All-Voiced</title>

        <meta name="description" content={article.meta.excerpt} />

        {/* Open Graph */}
        <meta
          property="og:title"
          content={`${article.meta.title} — All-Voiced`}
        />
        <meta property="og:description" content={article.meta.excerpt} />
        <meta
          property="og:image"
          content={`https://all-voiced.com${article.meta.coverImage}`}
        />
        <meta
          property="og:url"
          content={`https://all-voiced.com/insights/${slug}`}
        />
        <meta property="og:type" content="article" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <ArticleLayout meta={article.meta} readingTime={readingTime}>
        <Component references={article.meta.references} />
        <RelatedArticles article={article} />
      </ArticleLayout>
    </>
  );
}

export default InsightArticle;